import api from "@/services/api"

export type OnboardingStageName =
  | "start"
  | "end"
  | "confirm-user-identity"
  | "set-supervisor-pin"

type GetOutstandingStagesResponse = {
  stageNames: Array<OnboardingStageName>
}

export const getOutstandingStages =
  async (): Promise<GetOutstandingStagesResponse> => {
    const { body } =
      await api.get<GetOutstandingStagesResponse>(
        "/onboarding/outstanding-stages"
      )

    return body
  }
